import React from 'react'
import { useNavigate } from 'react-router-dom'
import GradientButton from '../components/GradientButton'
import { useT } from '../i18n'
import { useStoredPrincipal } from '../hooks/useStoredPrincipal'

export default function Start(){
  const navigate = useNavigate()
  const t = useT()
  const principal = useStoredPrincipal()
  const canManageFarms = principal?.role === 'editor' || principal?.role === 'admin'

  const name = principal?.actorId || principal?.role || ''

  return (
    <div>
      <h2 className="h2">{t('start.title')}</h2>
      <p className="lead">
        {name ? t('start.welcomeNamed', { name }) : t('start.welcomeAnon')}
      </p>

      <div style={{marginTop:14}}>
        <GradientButton
          onClick={() => {
            if (!canManageFarms) return
            navigate('/new-farm')
          }}
          disabled={!canManageFarms}
        >
          {t('start.createFacility')}
        </GradientButton>
      </div>
    </div>
  )
}
